import { type ReactElement } from 'react';
import { roadSituation } from '../LayerFactories';
import { LeafletMap } from '../Map';
import { SituationSource } from '../Sources/SituationSource';
import { TrafikenConfig } from '../TrafikenConfig';

import type { Map } from 'leaflet';
import type { PageMapProps } from './types';

interface SituationPageMapProps extends PageMapProps {
    situationId: number;
}

export const SituationPageMap = (props: SituationPageMapProps): ReactElement => {
    const mapProps = props.mapSettings;

    const setupMap = (map: Map): void => {
        roadSituation(null, null, {
            source: new SituationSource(null, null, null, {
                id: 'single-road-situation-source',
                url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/trafficmessages/${props.situationId}`,
                updateInterval: 0,
            }),
            name: 'SingleSituation',
            disablePopup: true,
            persistentInformationLayer: true,
            animate: false,
        }).addTo(map);
    };

    return <LeafletMap {...mapProps} disableFullscreenControl={true} startOnFeatureBounds={true} onMapInitiated={setupMap} />;
};
